import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import EventSeatOutlinedIcon from '@mui/icons-material/EventSeatOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RestaurantMenuOutlinedIcon from '@mui/icons-material/RestaurantMenuOutlined';
import SpeakerOutlinedIcon from '@mui/icons-material/SpeakerOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import { FormModel } from 'components/Form';
import React from 'react';
import PaymentsAccordion from '../PaymentsAccordion';

const sectionIcon = (Icon: React.ElementType) =>
  React.createElement(Icon, { fontSize: 'small', sx: { flexShrink: 0 } });

export const AddBeoForm = (
  strings: any,
  isPastBooking: boolean,
  sentToStaff: boolean,
  isAmendmentsPresent: boolean,
  pageData?: any,
  includeFlagsSaving = false,
): FormModel[] => {
  const disabled = isPastBooking || sentToStaff;

  const sectionHeader = (label: string, field: string, icon: React.ReactNode): FormModel => ({
    label,
    value: '',
    type: 'section',
    placeholder: '',
    field,
    autoFocus: false,
    validators: [],
    required: false,
    responsive: { xs: 12 },
    compactSection: true,
    sectionIcon: icon,
  });

  const editorField = (label: string, field: string): FormModel => ({
    label,
    value: '',
    autoFocus: true,
    type: 'textEditor',
    placeholder: '',
    field,
    validators: [],
    defaultSource: false,
    responsive: { xs: 12, lg: 6 },
    required: false,
    disabled,
  });

  const form: FormModel[] = [
    sectionHeader(
      strings.beo_section_food_beverage,
      'beo_section_food_beverage',
      sectionIcon(RestaurantMenuOutlinedIcon),
    ),
    editorField(strings.beo_menu_text, 'menu'),
    editorField(strings.beo_beverage_text, 'beverage'),

    sectionHeader(strings.beo_section_banquet_setup, 'beo_section_banquet_setup', sectionIcon(EventSeatOutlinedIcon)),
    editorField(strings.beo_room_setup_text, 'roomSetup'),
    editorField(strings.beo_program_text, 'program'),

    sectionHeader(strings.beo_section_technical, 'beo_section_technical', sectionIcon(SpeakerOutlinedIcon)),
    editorField(strings.beo_audio_visual_text, 'audioVisual'),
    editorField(strings.beo_engineering_text, 'engineering'),

    sectionHeader(strings.beo_section_operations, 'beo_section_operations', sectionIcon(CleaningServicesOutlinedIcon)),
    editorField(strings.beo_decor_text, 'decor'),
    editorField(strings.beo_security_text, 'security'),

    sectionHeader(
      strings.beo_section_commercials_billing,
      'beo_section_commercials_billing',
      sectionIcon(ReceiptLongOutlinedIcon),
    ),
    editorField(strings.beo_miscellaneous_text, 'miscellaneous'),
    editorField(strings.beo_billing_text, 'billing'),

    sectionHeader(strings.beo_notes_text, 'beo_section_general_notes', sectionIcon(StickyNote2OutlinedIcon)),
    {
      label: '',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: strings.beo_notes_placeholder,
      field: 'notes',
      multiline: true,
      minRows: 5,
      maxRows: 12,
      validators: [],
      responsive: { xs: 12 },
      required: false,
      disabled,
      sx: {
        '& .MuiOutlinedInput-root': {
          px: 1,
          py: 1,
        },
        '& .MuiInputBase-input': {
          px: 0,
          py: 0,
        },
        '& .MuiOutlinedInput-notchedOutline legend': { width: 0 },
        '& .MuiInputBase-root.Mui-disabled': {
          bgcolor: 'action.hover',
        },
      },
    },
    {
      label: null,
      value: null,
      type: 'custom',
      placeholder: '',
      field: 'paymentsAccordion',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
      children: pageData
        ? React.createElement(PaymentsAccordion, {
            payments: pageData.payments || [],
            paymentReceived: pageData.billingDetails?.advanceReceived || '',
            paymentDue: pageData.billingDetails?.paymentDue || '',
            totalCost: pageData.billingDetails?.totalCost || '',
          })
        : null,
    },
  ];

  isAmendmentsPresent &&
    form.push(
      {
        label: strings.beo_include_details_text,
        value: false,
        type: 'checkbox',
        field: 'includeBeoDetails',
        responsive: { xs: 6 },
        placeholder: '',
        validators: [],
        required: false,
        disabled: isPastBooking || includeFlagsSaving,
      },
      {
        label: strings.beo_include_amendments_text,
        value: false,
        type: 'checkbox',
        field: 'includeAmendments',
        responsive: { xs: 6 },
        placeholder: '',
        validators: [],
        required: false,
        disabled: isPastBooking || includeFlagsSaving,
      },
    );

  return form;
};
